'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ./~/eslint/~/js-yaml/index.js
// module id = 507
// module chunks = 0